var _path, _path2, _path3, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconBackupRecoverySmsDisabledmin = function SvgIconBackupRecoverySmsDisabledmin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 41,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.396 2.332H36.38v36.444H10.396z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M33.841 0H13.207c-1.369 0-2.68.54-3.648 1.501a5.1 5.1 0 0 0-1.511 3.624v30.75c0 1.36.543 2.663 1.51 3.624A5.18 5.18 0 0 0 13.208 41H33.84c1.368 0 2.68-.54 3.648-1.501A5.1 5.1 0 0 0 39 35.875V5.125c0-1.36-.544-2.663-1.51-3.624A5.18 5.18 0 0 0 33.84 0Zm-7.738 38.438h-5.158v-2.563h5.158zm7.738-6.407c0 .34-.136.666-.377.906-.242.24-.57.376-.912.376H14.496c-.342 0-.67-.136-.912-.376a1.28 1.28 0 0 1-.377-.906V6.406c0-.34.135-.665.377-.906.242-.24.57-.375.912-.375h18.056c.342 0 .67.135.912.375s.377.566.377.906z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M2.3 9.994a2.3 2.3 0 0 0-2.3 2.3v9.392a2.3 2.3 0 0 0 2.3 2.3h14.996l6.641 5.528c.282.235.7-.022.62-.38l-1.17-5.148h2.48a2.3 2.3 0 0 0 2.3-2.3v-9.391a2.3 2.3 0 0 0-2.3-2.3H2.301Z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.114,
    height: 1.999,
    x: 4.024,
    y: 13.992,
    fill: "#fff",
    rx: 0.999
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14.084,
    height: 1.999,
    x: 4.024,
    y: 17.99,
    fill: "#fff",
    rx: 0.999
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconBackupRecoverySmsDisabledmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_backup_recovery_sms_disabled.min.f203a1ab1cd24aee65400555df4932fb.svg";